import React from "react";
import { ToggleSwitch } from "MODULES/shared/containers";

export default function toggleSwitch(propName, initialValue = false) {
  return Component => props => (
    <ToggleSwitch visible={initialValue}>
      {(visible, open, close, toggle) => {
        const childProps = { ...props, [propName]: visible };

        return (
          <Component
            {...childProps}
            open={open}
            close={close}
            toggle={toggle}
          />
        );
      }}
    </ToggleSwitch>
  );
}



// WEBPACK FOOTER //
// ./app/modules/shared/decorators/toggleSwitch.jsx